import type { UserDto } from '@/backend/market/models/UserDto'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class UserNoteEntity {
  id?: string
  userId?: string
  user?: UserDto
  note?: string | null
  adminUserId?: string
  adminUser?: UserMiniEntity
  createdAt?: string
  updatedAt?: string | null
}
